export default {"src":"/_next/static/media/Comprehensive Wellness Programs.abfafcee.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};